// import Swiper JS
import Swiper from "swiper";
// core version + navigation, pagination modules:
import SwiperCore, {
    Navigation,
    Pagination,
    Mousewheel,
    Parallax,
    Thumbs,
    Lazy,
} from "swiper/core";
// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Mousewheel, Parallax, Thumbs, Lazy]);

// import Swiper styles
import "swiper/swiper-bundle.css";
import { URLASSOLUTO } from "./variables";

const swiper = $(document).ready(function () {

    let swiper0Opts = {
        lazy: true,
        preloadImages: true,
        autoHeight: false, //enable auto height
        debugger: true,
        loop: false,
        observer: true,
        observeParents: true,
        slidesPerView: 1,
        autoResize: false,
        navigation: {
            nextEl: ".swiper-button-next.swiper0",
            prevEl: ".swiper-button-prev.swiper0",
        }
    };
    var swiper0 = new Swiper(
        ".swiper-container.swiper0",
        swiper0Opts
    );

    // Get all of the swipers on the page
    $('.swiper-container.swiperrealizzazione').each(function () {
        let realizationgroupid = $(this).data("realizationgroupid");
        let swiperrealizzazioneOpts = {
            lazy: true,
            preloadImages: true,
            autoHeight: false, //enable auto height
            debugger: true,
            loop: false,
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            spaceBetween: 10,
            autoResize: false,
            navigation: {
                nextEl: `.swiper-button-next.swiperrealizzazione.swiper-next-${realizationgroupid}`,
                prevEl: `.swiper-button-prev.swiperrealizzazione.swiper-prev-${realizationgroupid}`,
            },
            breakpoints: {
                // when window width is >= 576px
                576: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                // when window width is >= 768px
                768: {
                    slidesPerView: 3.5,
                    spaceBetween: 20,
                },
            },
        };
        new Swiper(
            `.swiperrealizzazione-${realizationgroupid}`,
            swiperrealizzazioneOpts
        );
    });



    //swiper storia
    let swiperstoriaOpts = {
        lazy: true,
        preloadImages: true,
        autoHeight: false, //enable auto height
        debugger: true,
        loop: false,
        observer: true,
        observeParents: true,
        slidesPerView: 1,
        spaceBetween: 10,
        autoResize: false,
        navigation: {
            nextEl: ".swiper-button-next.swiperstoria",
            prevEl: ".swiper-button-prev.swiperstoria",
        },
        breakpoints: {
            // when window width is >= 576px
            576: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            // when window width is >= 768px
            768: {
                slidesPerView: 2,
                spaceBetween: 40,
            },
        },
    };
    var swiperstoria = new Swiper(
        ".swiper-container.swiperstoria",
        swiperstoriaOpts
    );

    let swiperprocessoOpts = {
        lazy: true,
        preloadImages: true,
        autoHeight: false, //enable auto height
        debugger: true,
        loop: false,
        observer: true,
        observeParents: true,
        slidesPerView: 1,
        spaceBetween: 10,
        autoResize: false,
        navigation: {
            nextEl: ".swiper-button-next.swiperprocesso",
            prevEl: ".swiper-button-prev.swiperprocesso",
        },
        breakpoints: {
            // when window width is >= 576px
            576: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
        },
        on : {
            slideChange: function () {
                const index_currentSlide      = this.realIndex;
                //const currentSlide            = this.slides[index_currentSlide];
                //console.log(index_currentSlide);
                $('.list-processo-item').removeClass('active');
                $('#list-processo-item'+index_currentSlide).addClass('active');
            }
        }


    };
    var swiperprocesso = new Swiper(
        ".swiper-container.swiperprocesso",
        swiperprocessoOpts
    );
    $(".list-processo-item").hover(function(){
        let swiperslideitem = $(this).data('item');
        //console.log('aaa'+swiperslideitem);
        swiperprocesso.slideTo(swiperslideitem);
    });

    let swiperprofiloOpts = {
        lazy: true,
        preloadImages: true,
        autoHeight: false, //enable auto height
        debugger: true,
        loop: false,
        observer: true,
        observeParents: true,
        slidesPerView: 1,
        spaceBetween: 10,
        autoResize: false,
        navigation: {
            nextEl: ".swiper-button-next.swiperprofilo",
            prevEl: ".swiper-button-prev.swiperprofilo",
        },
        breakpoints: {
            // when window width is >= 576px
            576: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
        }
    };
    var swiperprofilo = new Swiper(
        ".swiper-container.swiperprofilo",
        swiperprofiloOpts
    );


    let swiperapplicazioneOpts = {
        lazy: true,
        preloadImages: true,
        autoHeight: false, //enable auto height
        debugger: true,
        loop: true,
        observer: true,
        observeParents: true,
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 10,
        autoResize: false,
        navigation: {
            nextEl: ".swiper-button-next.swiperapplicazione",
            prevEl: ".swiper-button-prev.swiperapplicazione",
        },
        breakpoints: {
            // when window width is >= 576px
            576: {
                slidesPerView: 1.4,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 1.4,
                spaceBetween: 20,
            },
            1200: {
                slidesPerView: 2.8,
                spaceBetween: 20,
            },
        }
    };
    var swiperapplicazione = new Swiper(
        ".swiper-container.swiperapplicazione",
        swiperapplicazioneOpts
    );

    let swipersettore;

    function initSwiperIfNeeded() {
        // Controlla se la larghezza della finestra è inferiore a 768px
        if (window.innerWidth < 992) {
            if (!swipersettore) { // Se lo Swiper non è già inizializzato
                swipersettore = new Swiper(".swiper-container.swipersettore", swipersettoreOpts);
            }
        } else {
            // Se la larghezza della finestra è >= 768px, distruggi lo Swiper se esiste
            if (swipersettore) {
                swipersettore.destroy(true, true);
                swipersettore = null;
            }
        }
    }

    let swipersettoreOpts = {
        lazy: true,
        preloadImages: true,
        autoHeight: false, //enable auto height
        debugger: true,
        loop: true,
        observer: true,
        observeParents: true,
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 10,
        autoResize: false,
        navigation: {
            nextEl: ".swiper-button-next.swipersettore",
            prevEl: ".swiper-button-prev.swipersettore",
        },
        breakpoints: {
            // when window width is >= 576px
            576: {
                slidesPerView: 1.4,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 1.4,
                spaceBetween: 20,
            },
            1200: {
                slidesPerView: 2.8,
                spaceBetween: 20,
            },
        }
    };

    // Esegui la funzione all'avvio
    initSwiperIfNeeded();

    // Aggiungi un listener per la ridimensione della finestra
    window.addEventListener('resize', function() {
        initSwiperIfNeeded();
    });

});

export { swiper as default };
